import Vue from 'vue'
import App from './App.vue'

import router from "./router/index"
import store from "./store/index"
//导入自定义的插件
import plugins from './utils/plugins'

//Element UI引入
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// 设计系统：全局令牌 + Element-UI 皮肤（须在 element 样式之后引入）
import './styles/design.less';
import constant from "@/utils/constant";
import VueScrollTo from 'vue-scrollto';

//使用自定义的插件
Vue.use(plugins)
Vue.use(constant)
//导入Element UI插件

Vue.use(ElementUI)
Vue.use(VueScrollTo);

Vue.config.productionTip = false

Vue.use(require("./components/carkeyboard/js/tap.js"));


import {sentHeartbeat} from "@/api/device-api"

// 终端心跳：纯 H5 部署没有安卓壳，只要绑定了设备就保持心跳
let timer = setInterval(() => {
    let deviceId = store.state.deviceId
    if (deviceId) {
        sentHeartbeat(deviceId).then(({data}) => {
            console.log("@@@ sentHeartbeat result : " + JSON.stringify(data))
        }).catch(err => {
            console.log("@@@ sentHeartbeat result err: " + err)
        })
    }

}, 30 * 1000)


new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
